import angular = require("angular"); 
import toastr = require("toastr"); 

import { directivesModule } from "../directivesModule";
import "./Overlay";

interface ICountdownObject {
	message: string,
	countdownFrom: number,
	timeLeft: number,
	callback: () => void,
	toastObject: JQuery<HTMLElement>,
	interval: angular.IPromise<any>
}

export class Notifications {

	constructor(private $rootScope: angular.IRootScopeService, private $window: angular.IWindowService, private $interval: angular.IIntervalService) {

		if (toastr) {
			toastr.options.closeButton = true;
			toastr.options.positionClass = 'toast-bottom-right';
		}
		else {
			if (console && console.error) {
				console.error("toastr has not been loaded.");
			}
		}
	}

	public warning(p:string, title?:string) {
		toastr.warning(p, title);
	};

	public success(p:string, title?:string) {
		toastr.success(p, title);
	}

	public error(p:any, title?:string) {
		if (p && p.ExceptionMessage) {
			toastr.error(p.ExceptionMessage, title);
		}
		else if (p && p.Message) {
			toastr.error(p.Message, title);
		}

		else {
			toastr.error(p, title);
		}
	};

	//This is a list of countdowns.  It is kept so that we can cancel countdowns easily.  
	private activeCountdowns: {
		[key: string]: ICountdownObject
	} = {};

	//Create a countdown toast.  The message will be the title and the seconds remaining will appear in the body.  When the 
	//countdown completes the callback will be executed.  The key provided can be any string.  
	public countdown(key: string, message: string, countdownFrom: number, callback: () => void): string  {
		//Make sure we cancel any countdowns that already exist with this key,  Cancel will do nothing if a countdown doesn't already exist. 
		this.cancelCountdown(key);

		let countdownObject: ICountdownObject = {
			message:message, countdownFrom:countdownFrom, timeLeft:countdownFrom, callback:callback, toastObject:null, interval:null 
		};
		countdownObject.toastObject = toastr.warning(String(countdownFrom), message, {
			timeOut: 0, extendedTimeOut: 0
		})
		countdownObject.interval = this.$interval(() => {
			//Reduce the time left by 1 second. 
			countdownObject.timeLeft -= 1;

			//Find the body in the toast and set it to the seconds remaining.  
			countdownObject.toastObject.children(".toast-message").html(String(countdownObject.timeLeft));

			//If the countdown is complete then call the callback and hide the toast.  
			if (countdownObject.timeLeft <= 0) {
				this.cancelCountdown(key);
				countdownObject.callback(); 
			}
		}, 1000, countdownFrom, true);

		//Save the countdown object in a local cache.  
		this.activeCountdowns[key] = countdownObject;

		return key;
	}

	//This will do nothing if there is not already a countdown with this key.  
	public cancelCountdown(key: string) {
		
		var countdownObject = this.activeCountdowns[key];
		if (countdownObject) {
			toastr.clear(countdownObject.toastObject);
			this.$interval.cancel(countdownObject.interval);
			this.activeCountdowns[key] = null; 
		}
		
	}

	public clear() {
		toastr.clear();
	}

	public showOverlay() {
		this.$window.scrollTo(0, 0);
		this.$rootScope.$broadcast('showOverlay');
	}

	public hideOverlay() {
		this.$rootScope.$broadcast('hideOverlay');
	}

}

directivesModule.service('notifications', ['$rootScope', '$window','$interval', ($rootScope, $window, $interval) => new Notifications($rootScope, $window, $interval)]);





// WEBPACK FOOTER //
// ./Common/Notifications/Notifications.ts